var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_12519_21405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.49341 0 0 4.49417 0 10C0 15.5066 4.49417 20 10 20C15.5066 20 20 15.5058 20 10C20 4.49326 15.5058 0 10 0ZM10 18.8281C5.13214 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13214 5.13214 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13214 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.72656 7.07031V12.9297H7.46094L12.9297 17.0312V2.96875L7.46094 7.07031H4.72656ZM7.07031 11.7578H5.89844V8.24219H7.07031V11.7578ZM11.7578 14.6875L8.24219 12.0508V7.94922L11.7578 5.3125V14.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.5867 8.75629C14.2719 9.44171 14.2719 10.5568 13.5867 11.2422L14.4152 12.0708C15.5575 10.9285 15.5575 9.07001 14.4152 7.92773L13.5867 8.75629Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.3285713bc20d2f7eeaaa7bca67156ecf.svg";
export { ForwardRef as ReactComponent };